import { Slider } from '../ui/slider';
import { RotateCcw } from 'lucide-react';

export default function TunerPanel({ paramDefs, paramVals, setParam, resetParams }) {
  const entries = Object.entries(paramDefs);
  if (!entries.length) {
    return (
      <div data-testid="tuner-empty" className="text-xs text-slate-400 t-chat leading-relaxed">
        Questo gioco non espone parametri live. Chiedi a THE ARCHITECT: <span className="text-cyan-300">"integra il Live Variable Tuner TITAN"</span>.
      </div>
    );
  }
  return (
    <div data-testid="tuner-panel" className="space-y-6">
      <div className="flex items-center justify-between">
        <span className="t-label">Live Variable Tuner</span>
        <button data-testid="tuner-reset-btn" onClick={resetParams} className="flex items-center gap-1 text-[10px] text-slate-400 hover:text-cyan-300 transition-colors"><RotateCcw className="h-3 w-3" />RESET</button>
      </div>
      {entries.map(([k, d]) => (
        <div key={k} className="space-y-2.5">
          <div className="flex justify-between text-xs">
            <span className="text-slate-300">{d.label || k}</span>
            <span data-testid={`tuner-value-${k}`} className="font-bold text-cyan-300 tabular-nums">{Number(paramVals[k] ?? d.v).toFixed(d.step < 1 ? 2 : 0)}</span>
          </div>
          <Slider data-testid={`tuner-slider-${k}`} min={d.min ?? 0} max={d.max ?? 100} step={d.step ?? 1} value={[paramVals[k] ?? d.v]} onValueChange={([v]) => setParam(k, v)} />
        </div>
      ))}
      <p className="text-[10px] text-slate-500 t-chat">Le modifiche si applicano al frame successivo, senza ricompilare.</p>
    </div>
  );
}
